import { ExclamationCircleIcon } from '@heroicons/react/solid'
import { useState } from 'react'

export default function ColorField(props) {
    const { label, input, meta, placeholder = null, col = 3, required = false, defaultValue=null } = props
    const [colorPick, setColorpick] = useState(defaultValue);


   function handelChange(e){

    setColorpick(e.target.value);
    input.onChange(e.target.value);
   } 
    //console.log(input)

    return (
        <div className={'col-span-12 sm:col-span-'+col}>
            <label htmlFor={input.name} className="block text-sm font-medium text-gray-700">
                {label} {required && <span className="text-red-500">*</span>}
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
                <input
                    {...input}
                    type="color"
                    placeholder={placeholder}
                    value={colorPick}
                    onChange={(e)=>handelChange(e)}
                    className={ (meta.error && meta.touched) ? 'block w-full pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm rounded-md' : 'shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md'}
                />
                {meta.error && meta.touched && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                </div>}
            </div>
            {meta.error && meta.touched && <p className="mt-2 text-sm text-red-600">{meta.error}</p>}
        </div>
    )
}